import { Request } from '../request';

import type { IGetProviderMappingDataInput } from 'types/operation';

export const getPPAProviderList = (data: IGetProviderMappingDataInput) => Request.post({ url: '/admin-server/klarity/page/data', params: data });
export const exportPPAProviderList = () => Request.get({ url: '/admin-server/provider/mapping/ppa/export' });

export const getPPAServicePriceConfigOPS = (state: string[]) => Request.post({ url: '/admin-server/provider/klarity/service/price/list', params: state });
